import * as yup from 'yup';
import { AppTFunction } from '@retail/app/i18n';
import { safeTextRegex } from '@retail/form/validation';

export const roundingRuleRangeSchema = (t: AppTFunction) =>
  yup.object({
    priceFrom: yup.number().price(t).required(t('validation.required')),
    priceTo: yup
      .number()
      .price(t)
      .optional()
      .when('priceFrom', {
        is: (priceFrom: number) => priceFrom != null,
        then: (schema) =>
          schema.test(
            'is-greater-than-priceFrom',
            t('rounding.validation.priceTo.mustBeGreaterThanPriceFrom'),
            function (priceTo) {
              const { priceFrom } = this.parent;
              if (priceTo == null || priceFrom == null) return true;
              return priceTo > priceFrom;
            }
          ),
      }),
    roundingMode: yup.string().required(t('validation.required')),
    targetEndings: yup
      .array(yup.number().price(t).required(t('validation.required')))
      .when('roundingMode', {
        is: (val: string) => val === 'ROUND_UP' || val === 'CLOSEST',
        then: (schema) => schema.required(t('validation.required')),
        otherwise: (schema) => schema.optional(),
      }),
  });

export const priceRoundingRuleConfigSchema = (t: AppTFunction) =>
  yup.object({
    name: yup
      .string()
      .matches(safeTextRegex, t('validation.safeText'))
      .required(t('validation.required')),
    rules: yup
      .array(roundingRuleRangeSchema(t))
      .min(1)
      .required(t('validation.required'))
      .test(
        'last-price-to-is-not-set',
        t('rounding.validation.rules.mustHaveOpenEnd'),
        function () {
          const lastRule = this.parent.rules[this.parent.rules.length - 1];
          return lastRule.priceTo == null || lastRule.priceTo === '';
        }
      ),
  });

export type RoundingRuleRangeSchema = yup.InferType<ReturnType<typeof roundingRuleRangeSchema>>;
export type PriceRoundingRuleConfigSchema = yup.InferType<
  ReturnType<typeof priceRoundingRuleConfigSchema>
>;
